module.exports = __webpack_public_path__ + "img/square.5db8d0ea.svg";